<app-capture-history-item-title>
  {{ displayStatus }}
</app-capture-history-item-title>

<app-capture-history-item-body>
  <p>
    {{ description }}

    @if (captureHistoryItem.relatedRecord) {
      via peer capture
      <a href="/capture-admin/captures/{{ captureHistoryItem.relatedRecord.id }}" target="_blank">{{ captureHistoryItem.relatedRecord.claimIdentifier }}</a>.
    }
  </p>

  @if (additionalDetails) {
    <p>
      Additional Details: {{ additionalDetails }}
    </p>
  }

  @if (verifiedDuringNoReferralPeriod) {
    <p>
      CE's policies and procedures supported a verification without a referral on file at the time of verification.
    </p>
  }
</app-capture-history-item-body>
